export enum RolesGroup {
    Global = 0,
    Partner = 1,
    Site = 2,
}
